module.exports = __webpack_public_path__ + "img/portraits_01_V.6fc8fe91.webp";